 
import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import api from 'services/api';
import Fallback from 'v3/components/Fallback';
import Text from 'v3/components/Text';
import Card from 'v3/components/Card';
import moment from 'moment';
import theme from 'v3/theme';
import { useSnackbar } from 'v3/components/Snackbar';
import { useTravel } from 'v3/pages/Travel';
import { Attachment } from './Attachment';
import * as Styled from './styles';

export function TravelDriverAttachments() {
  const travel = useTravel();
  const snackbar = useSnackbar();
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMissingAttachment, setIsMissingAttachment] = useState(false);
  const [hasExpiredAttachment, setHasExpiredAttachment] = useState([]);
  const requiredDocumentTypes = ['CNH', 'RG', 'LIBERAÇÂO GR', 'COMPROVANTE ENDEREÇO'];

  function isDateValid(value) {
    const date = moment(value, 'DD/MM/YYYY');
    return value?.split('/')?.length === 3 && date.isValid() && date.isAfter(moment());
  }

  async function fetchAttachments() {
    try {
      setLoading(true);
      const response = await api.get(`driver/${travel?.data?.driverId}/attachments`);
      setAttachments(response.data);
    } catch (error) {
      snackbar.show('Não foi possível recuperar documentos anexados para o motorista', {
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (attachments) {
      attachments.forEach((document) => {
        if (!isDateValid(document.due_data)) {
          setHasExpiredAttachment([...hasExpiredAttachment, document.type]);
        }
      });
      if (attachments.length < 3) {
        setIsMissingAttachment(true);
      }
    }
  }, [attachments]);

  useEffect(() => {
    if (travel?.data?.driverId && travel?.data?.driverId !== 0) {
      fetchAttachments();
    }
  }, [travel?.data?.driverId]);

  return (
    <>
      <Card
        header={
          <Text color="#464E5F" type="header">
            Anexos do Motorista
          </Text>
        }
        loading={loading || travel.isLoading}
      >
        <>
          <Fallback
            component={
              <Col xs={12} className="align-items-center d-flex flex-column my-2">
                <Text color={theme.colors.gray}>Não há anexos cadastrados para o motorista.</Text>
              </Col>
            }
            fall={!attachments?.length}
          >
            <Row
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
              }}
            >
              <>
                <Styled.UlItem>
                  {attachments?.map((attachment) => {
                    return (
                      <Col xs={12} className="d-flex flex-column" key={attachment?.created_at}>
                        <Attachment attachment={attachment} attachments={attachments} />
                      </Col>
                    );
                  })}
                  {isMissingAttachment ? (
                    <Text type="regular" className="mt-4 mb-4" id="text">
                      Atenção, há documentos faltando! Os seguintes documentos são necessários para
                      o motorista:
                      {requiredDocumentTypes.map((document, index) => {
                        return (
                          <span key={document}>
                            {' '}
                            {document}
                            {index < requiredDocumentTypes.length - 1 ? ',' : ''}
                          </span>
                        );
                      })}
                    </Text>
                  ) : null}
                </Styled.UlItem>
              </>
            </Row>
          </Fallback>
        </>
      </Card>
    </>
  );
}
